import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { setupAdminApiInterceptors } from "@/lib/adminApi";
import { getAppUnlockToken } from "@/lib/appUnlockStorage";

// Attach app unlock token only to admin API requests
const originalFetch = window.fetch;
window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";
  if (url.includes("/api/admin/")) {
    const token = getAppUnlockToken();
    if (token) {
      const headers = new Headers(init.headers || {});
      headers.set("X-App-Unlock-Token", token);
      init = { ...init, headers };
    }
  }
  return originalFetch(input, init);
};

setupAdminApiInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
